import React from 'react';
import { Typography } from '@mui/material';
import Tooltip from '@src/components/Tooltip';
import classnames from 'classnames';
import { StyledImportantTag } from './index.style';

const ImportantTag = ({
  icon,
  tag,
  bgColor,
  color,
  right,
  top,
  padding,
  borderRadius,
  cancelAbsolute,
  contentTooltip,
}) => (
  <Tooltip
    disableInteractive={!contentTooltip}
    disableTouchListener={!contentTooltip}
    arrow
    title={contentTooltip || ''}
    placement="left"
    textAlign="left"
  >
    <StyledImportantTag
      cancelAbsolute={cancelAbsolute}
      bgColor={bgColor}
      color={color}
      right={right}
      top={top}
      padding={padding}
      borderRadius={borderRadius}
    >
      <Typography
        className={classnames('new-label-text', {
          'has-icon': !!icon,
        })}
      >
        {icon}
        {tag}
      </Typography>{' '}
    </StyledImportantTag>
  </Tooltip>
);
export default ImportantTag;
